import PdfSigner from "components/contract/PdfSigner";

function Contract() {
    return (
        <div>
            <PdfSigner file={"/contract.pdf"} />
        </div>
    );
}   

export default Contract;
